import React, { Component } from 'react';
import './Introduction.css';

import introduction from './.image/introduction.png';

export class Introduction extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    }


    render() {
        return (
            <div className="introduction">
                <img src={introduction} alt="introduction" />
            </div>
        );
    }
}